import type { QueryClient } from '@tanstack/react-query';
import {
  REPLY_QUEUE_COUNT_QUERY_KEY,
  REPLY_QUEUE_ROWS_QUERY_KEY,
} from '@/hooks/useReplyQueue';

/**
 * Marks both materializations of Reply Queue membership stale in one place.
 * Active observers refetch together; inactive full-row caches are only
 * marked stale, so message bodies are still fetched only when the tab opens.
 */
export async function invalidateReplyQueueMembership(
  queryClient: QueryClient
): Promise<void> {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: REPLY_QUEUE_ROWS_QUERY_KEY }),
    queryClient.invalidateQueries({ queryKey: REPLY_QUEUE_COUNT_QUERY_KEY }),
  ]);
}
